import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { environment } from 'src/environments/environment';
import { DatePipe } from '@angular/common';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
};

const httpSpaceOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
  }),
};

const httpFileDownloadHttOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    observe: 'response',
    responseType: 'blob',
    accept: '*',
  }),
};

@Injectable()
export class IssueDataService {
  baseUrl: string = '';

  httpOptions: any;

  //Services
  _datePipe = inject(DatePipe);

  constructor(private http: HttpClient) {
    this.baseUrl = environment.spaceEngineRestServer;
  }

  reportInvoiceIssue(invoiceNumber: string, message: string) {
    return this.http.post(`${this.baseUrl}issuenotification/invoiceerror/${invoiceNumber}`, {
      observe: 'response',
      responseType: 'blob',
    });
  }

  private handleError(error: HttpErrorResponse) {
    console.error('handleErrorHttpRequest', error);
    if (error.error instanceof Error) {
      console.error('Error thrown: ' + JSON.stringify(error));
      const errMessage = error.error.message;
      return throwError(() => errMessage);
      // Use the following instead if using lite-server
      // return Observable.throw(err.text() || 'backend server error');
    }
    return throwError(() => error || 'server error');
  }
}
